import { render } from "./Textarea.vue?vue&type=template&id=20957e0e"
import script from "./Textarea.vue?vue&type=script&lang=js"
export * from "./Textarea.vue?vue&type=script&lang=js"

import "./Textarea.vue?vue&type=style&index=0&id=20957e0e&lang=css"
script.render = render

export default script